module.exports = __webpack_public_path__ + "static/img/yijianfankui_bg.4904b4f6.png";